// extracted by mini-css-extract-plugin
export var childrenContainer = "_ck-0";
export var virtualScrollArea = "_ck-1";